export default __webpack_public_path__ + "static/media/blue-dot.248cabcf.svg";